var map = {
	"./assets.js": 24863,
	"./facescan.js": 22241,
	"./game.js": 52983,
	"./task.js": 72390,
	"./upgrade.js": 70401,
	"./user.js": 59081,
	"./wallet.js": 9944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80095;